import React, { ReactElement } from 'react';
import { Canvas, extend, ThreeElement, useThree } from '@react-three/fiber';
import { MOUSE } from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';

import ReferenceGridVisual from './ReferenceGridVisual';

declare module '@react-three/fiber' {
  interface ThreeElements {
    orbitControls: ThreeElement<typeof OrbitControls>;
  }
}

extend({ OrbitControls });

function Controls() {
  const { camera, gl } = useThree();
  return (
    <orbitControls
      args={[camera, gl.domElement]}
      enableRotate={false}
      mouseButtons={{ LEFT: MOUSE.RIGHT, MIDDLE: MOUSE.MIDDLE, RIGHT: MOUSE.LEFT }}
      screenSpacePanning
    />
  );
}

interface Props {
  readonly width: number;
  readonly height: number;
  readonly children: ReactElement | readonly ReactElement[];
}

function ThreeJsScene(props: Props) {
  const { width, height, children } = props;

  return (
    <div
      style={{
        lineHeight: '0',
        width,
        height,
        minWidth: '5px',
        minHeight: '5px',
      }}
    >
      <Canvas
        gl={{
          alpha: false,
          antialias: true,
        }}
        orthographic
        dpr={1}
      >
        <Controls />
        <ambientLight color={0xaaaaaa} />
        <directionalLight color={0xaaaaaa} intensity={1.1} position={[3, 4, 10]} />
        <ReferenceGridVisual />
        {children}
      </Canvas>
    </div>
  );
}

export default ThreeJsScene;
